// extracted by mini-css-extract-plugin
export default {"main":"styles_main__dURJS","left":"styles_left__KGZFT","right":"styles_right__FQa3s","percentage":"styles_percentage__UOpNw"};